'use client'

import { useMutation } from "@tanstack/react-query"
import { API_Error, API_Success_Response } from "@/interfaces/api/response/api_response_types"
import { submitExitSurvey } from "../requests/survey"
import { SubmitSurveyPayload } from "@/interfaces/api/survey/api_request_types"

export const useSubmitExitSurvey = () => useMutation<API_Success_Response<undefined>, API_Error, SubmitSurveyPayload>({
  retry: false,
  mutationFn: submitExitSurvey
})